import React from 'react'
import styles from './index.module.scss'
import cn from 'classnames'

interface ButtonProps {
  children: React.ReactNode
  onClick?: () => void
  disabled?: boolean
  buttonType?: 'button' | 'submit' | 'reset'
  className?: string
  type?: 'primary' | 'secondary'
  icon?: React.ReactNode
  loading?: boolean
}

const Button: React.FC<ButtonProps> = ({
  children,
  onClick,
  disabled = false,
  buttonType = 'button',
  className,
  type = 'primary',
  icon,
  loading = false
}) => {
  const isDisabled = disabled || loading

  return (
    <button
      className={cn(styles.button, styles[type], className, {
        [styles.loading]: loading
      })}
      onClick={onClick}
      disabled={isDisabled}
      type={buttonType}
    >
      {loading ? (
        <span className={styles.loadingIcon}>
          <span className={styles.spinner}></span>
        </span>
      ) : (
        icon && <span className={styles.icon}>{icon}</span>
      )}
      <span className={styles.buttonText}>{children}</span>
    </button>
  )
}

export default Button
